import React from 'react';

import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';

import QuoteMarkdown from '../../common/QuoteMarkdown';

const FACEBOOK_TITLE = 'Ezt a tervet a Facebookon leírt kérésed alapján készítettük';

interface QuoteDescriptionDialogProps {
    open: boolean;
    onClose: () => void;
    description: string;
    title?: string;
    buttonLabel?: string;
}

/** Markdown popup: Facebook intro (default) or price info. */
const QuoteDescriptionDialog: React.FC<QuoteDescriptionDialogProps> = ({
    open, onClose, description, title = FACEBOOK_TITLE, buttonLabel = 'Megnézem 3D-ben',
}) => (
    <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        scroll="paper"
        PaperProps={{ sx: { bgcolor: '#fff', color: '#000', borderRadius: 2 } }}
    >
        <DialogTitle sx={{ fontWeight: 'bold', color: '#000' }}>{title}</DialogTitle>
        <DialogContent>
            {description && <QuoteMarkdown markdown={description} />}
        </DialogContent>
        <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button variant="contained" onClick={onClose} autoFocus>{buttonLabel}</Button>
        </DialogActions>
    </Dialog>
);

export default QuoteDescriptionDialog;
